const cards = [
  {
    title: '明星婚变内幕：知情人独家爆料分手费惊人数字',
    excerpt: '据多位圈内人士透露，这场离婚案背后涉及的财产分割远超外界想象，双方律师团队已交锋数轮。',
    image: 'https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20illustration%20of%20entertainment%20news%20with%20soft%20coral%20and%20warm%20peach%20gradients%2C%20abstract%20composition%20showing%20silhouettes%20and%20drama%20elements%2C%20modern%20magazine-style%20flat%20design%2C%20warm%20minimal%20background%20with%20geometric%20accents&width=600&height=400&seq=card-1-2026&orientation=landscape',
    tag: '娱乐八卦',
    time: '3小时前',
    views: '89万',
  },
  {
    title: '某互联网大厂裁员风波内部邮件流出，员工群炸了',
    excerpt: '一份据称是内部全员邮件在社交平台疯传，涉及多个业务线调整和人员优化方案。',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20digital%20art%20depicting%20tech%20office%20drama%20with%20warm%20amber%20and%20coral%20hues%2C%20abstract%20floating%20document%20icons%20and%20notification%20symbols%2C%20soft%20editorial%20style%20with%20clean%20geometric%20lines%2C%20warm%20minimal%20background&width=600&height=400&seq=card-2-2026&orientation=landscape',
    tag: '科技财经',
    time: '5小时前',
    views: '72万',
  },
  {
    title: '综艺录制现场导演与嘉宾起冲突，全场哗然',
    excerpt: '据现场观众爆料，某热门综艺节目在录制过程中突发意外状况，嘉宾当场离场。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20yet%20artistic%20illustration%20of%20TV%20show%20drama%20with%20warm%20peach%20and%20coral%20gradients%2C%20stage%20lighting%20abstract%20shapes%20and%20spotlight%20effects%2C%20modern%20flat%20design%20style%2C%20soft%20composition%20with%20floating%20elements&width=600&height=400&seq=card-3-2026&orientation=landscape',
    tag: '娱乐八卦',
    time: '6小时前',
    views: '68万',
  },
  {
    title: '连锁餐饮品牌后厨卫生被曝光，市监局连夜突击',
    excerpt: '暗访视频在社交平台引发巨大反响，该品牌多家门店被责令停业整顿。',
    image: 'https://readdy.ai/api/search-image?query=A%20clean%20conceptual%20illustration%20of%20food%20safety%20news%20with%20warm%20amber%20tones%2C%20abstract%20kitchen%20elements%20and%20warning%20symbols%20in%20soft%20modern%20design%2C%20editorial%20quality%20with%20warm%20peach%20background%20and%20geometric%20accents&width=600&height=400&seq=card-4-2026&orientation=landscape',
    tag: '社会热点',
    time: '8小时前',
    views: '55万',
  },
  {
    title: '年度游戏大作发售首日服务器崩溃，玩家集体吐槽',
    excerpt: '期待已久的3A大作正式发售，却因在线人数远超预期导致服务器大面积瘫痪。',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20gaming-themed%20illustration%20with%20warm%20coral%20gradients%2C%20abstract%20game%20controller%20shapes%20and%20digital%20effects%2C%20modern%20flat%20design%20with%20soft%20floating%20elements%2C%20warm%20peach%20background%20with%20geometric%20patterns&width=600&height=400&seq=card-5-2026&orientation=landscape',
    tag: '体育电竞',
    time: '10小时前',
    views: '48万',
  },
  {
    title: '知名投资人公开发声质疑某独角兽公司估值虚高',
    excerpt: '该投资人连发多条长文指出公司财务数据存在多处疑点，引发投资圈广泛讨论。',
    image: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20business-themed%20abstract%20illustration%20with%20warm%20amber%20and%20coral%20accents%2C%20floating%20chart%20and%20graph%20elements%2C%20modern%20clean%20editorial%20style%2C%20warm%20minimal%20background%20with%20subtle%20textures&width=600&height=400&seq=card-6-2026&orientation=landscape',
    tag: '科技财经',
    time: '12小时前',
    views: '42万',
  },
  {
    title: '热门电视剧大结局编剧被骂上热搜，观众要寄刀片',
    excerpt: '期待数月的大结局播出后观众集体破防，社交媒体上吐槽声此起彼伏。',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20TV-themed%20illustration%20with%20warm%20peach%20and%20coral%20gradients%2C%20abstract%20film%20strip%20and%20drama%20elements%2C%20modern%20editorial%20flat%20design%2C%20soft%20floating%20composition%20with%20geometric%20shapes%20on%20warm%20background&width=600&height=400&seq=card-7-2026&orientation=landscape',
    tag: '娱乐八卦',
    time: '15小时前',
    views: '38万',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          热门资讯
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          精选全网热门吃瓜资讯，每一条都值得细细品味
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {cards.slice(0, 3).map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="h-[180px] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {item.excerpt}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-eye-line"></i>
                  </span>
                  {item.views} 阅读
                </div>
              </div>
            </article>
          ))}
          {cards.slice(3).map((item, idx) => (
            <article
              key={idx + 3}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer lg:col-span-1 xl:col-span-1"
            >
              <div className="flex sm:flex-col">
                <div className="w-[120px] sm:w-full h-auto sm:h-[160px] flex-shrink-0 overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                  />
                </div>
                <div className="flex-1 p-4">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-2">
                    {item.excerpt}
                  </p>
                  <div className="flex items-center gap-1 text-xs text-foreground-400">
                    <span className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-eye-line"></i>
                    </span>
                    {item.views} 阅读
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}